module.exports = __webpack_public_path__ + "img/slide-26.298cf2d4.jpeg";